import * as yup from 'yup'

const dateOfBirthMinMax = () => {

  const currentYear = new Date().getFullYear()
  const minYear = currentYear - 100
  const maxYear = currentYear - 18

  return yup
  .mixed<number | null>()
  .nullable()
  .notRequired()
  .transform((value: unknown, originalValue: unknown): number | null => {
    if (!originalValue || originalValue === '') {
      return null
    }

    const stringValue = String(originalValue)
    const yearMatch = stringValue.match(/\b(19\d{2}|20\d{2})\b/)
    if (!yearMatch) {
      return null
    }
    return parseInt(yearMatch[0], 10)
  })
  .test(
    'is-valid-age',
    function(value: number | null): boolean | yup.ValidationError {
      if (value === null) {
        return true
      }
      
      if (value < minYear) {
        return this.createError({
          message: `De leeftijd mag niet hoger zijn dan 100 jaar (geboren na ${minYear})`
        })
      }
      
      if (value > maxYear) {
        return this.createError({
          message: `Je dient minimaal 18 jaar oud te zijn (geboren voor ${maxYear + 1})`
        })
      }
      
      return true
    }
  )
}

export default dateOfBirthMinMax